import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type SkillDetailsFragment = { __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null };


export type SkillDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type SkillDetailsWithAttachedEntitiesFragment = { __typename: 'SkillType', id: string, name: string, description?: string | null, type: Types.SkillTypeEnum, systemGenerated?: boolean | null, attachedToEntitiesCount?: { skillMatricesCount: number, contentsCount: number } | null, scaleConfig?: { maxScore: number, minScore: number, scaleType: Types.ScaleConfigEnum } | null, rubrics: Array<{ label: string, score?: number | null, description?: string | null, maxScore?: number | null, minScore?: number | null }>, iconSettings?: { value: string, type: Types.IconTypeEnum, iconColor?: string | null } | null };


export type SkillDetailsWithAttachedEntitiesFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SkillDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment SkillDetails on SkillType {
  id
  name
  description
  type
  scaleConfig {
    maxScore
    minScore
    scaleType
  }
  systemGenerated
  rubrics {
    label
    score
    description
    maxScore
    minScore
  }
  iconSettings {
    value
    type
    iconColor
  }
  __typename
}
    `;
export const SkillDetailsWithAttachedEntitiesFragmentDoc = /*#__PURE__*/ gql`
    fragment SkillDetailsWithAttachedEntities on SkillType {
  ...SkillDetails
  attachedToEntitiesCount {
    skillMatricesCount
    contentsCount
  }
}
    `;